import {store} from "@/store/store";

const scriptLink = { // ссылка на скрипт
  dev: 'https://application-site-ppd.vsegda-da.com/vd-online.js',
  prod: 'https://application.vsegda-da.com/vd-online.js',
};

/** Подключить виджет оплат через Хоум банк
 * @param {Boolean} isTestPay - является ли платеж тестовым
* */
export let connectVsegdaDa = (isTestPay) => {
  if (!store.state.isPaymentsVsegdaDaScript) {
    let script = document.createElement('script');
    let head = document.head || document.documentElement.childNodes[0];

    script.type = 'text/javascript';
    script.src = isTestPay ? scriptLink.dev : scriptLink.prod;
    head.appendChild(script);
    store.commit('setStatusVsegdaDaScript', true);
  }
};